require('./domains/poster-automation')


import Datepicker from 'vuejs-datepicker';

Vue.component('filler', require('@/components/Filler.vue'));
Vue.component('filler-magazine', require('@/components/magazineluiza/Filler.vue'));
Vue.component('loader', () => import('@/components/Loader.vue'));
Vue.component('search', require('@/components/SearchTemplate.vue'));
Vue.component('cards-list', () => import('@/components/CardsList.vue'));
Vue.component('cards-list-theme', () => import('@/components/CardsListTheme.vue'));
Vue.component('release-posters', () => import('@/components/release-posters/ReleasePosters.vue'));
Vue.component('data-list-component', require('@/components/data-component/DataListComponent.vue'));
Vue.component('data-list', require('@/components/data-component/DataList.vue'));
Vue.component('horizontal-data-list-component', require('@/components/HorizontalDataList.vue'));
Vue.component('infinity-scroll-data-list-component', () => import('@/components/InfinityScrollDatalist.vue'));
Vue.component('infinity-scroll-data-list', require('@/components/InfinityScroll.vue'));
Vue.component('posters-data-list', require('@/components/data-component/PostersDatalist.vue'));
Vue.component('posters-actions', require('@/components/PostersActions.vue'));
Vue.component('draft-posters-actions', require('@/components/poster-automation/DraftPostersActions.vue'));
Vue.component('form-draft-poster', require('@/components/FormDraftPoster.vue'));
Vue.component('posters-content', require('@/components/PostersContent.vue'));
Vue.component('order-select', () => import('@/components/data-component/OrderSelect.vue'));
Vue.component('tab-select', () => import('@/components/data-component/TabSelect.vue'));
Vue.component('accounts-list', () => import('@/components/AccountsList.vue'));
Vue.component('modal-training', require('@/components/ModalTraining.vue'));
Vue.component('modal-register-store', require('@/components/ModalRegisterStore.vue'));
Vue.component('customize-templates', () => import('@/components/CustomizeTemplates.vue'));

Vue.component('promotion-store', () => import('@/components/PromotionStore.vue'));
Vue.component('filter-select', () => import('@/components/filters/Select.vue'));
Vue.component('has-error', () => import('@/components/HasError.vue'));
Vue.component('vueup', () => import('@/components/VueUp.vue'));
Vue.component('create-store-products', () => import('@/components/CreateStoreProducts.vue'));
Vue.component('print-quantity-and-license-sharing', () => import('@/components/PrintQuantityAndLicenseSharing.vue'));
Vue.component('license-customization-fields', () => import('@/components/LicenseCustomizationFields.vue'));
Vue.component('license-acquired-fields', () => import('@/components/LicenseAcquiredFields.vue'));

Vue.component('share-posters', require('@/components/SharePosters.vue'));
Vue.component('share-posters-modal', require('@/components/SharePostersModal.vue'));
Vue.component('poster-modal', () => import('@/components/PosterModal.vue'));

Vue.component('custom-register-templates', () => import('@/components/CustomRegisterTemplates.vue'));

Vue.component('update-order-invoice-data', () => import('@/components/UpdateOrderInvoiceData.vue'));

Vue.component('upload-account-files', () => import('@/components/UploadAccountFiles.vue'));

Vue.component('input-file', () => import('@/components/InputFile.vue'));
Vue.component('drag-and-drop', () => import('@/components/DragAndDrop.vue'));

Vue.component('user-register-steps', () => import('@/components/UserRegisterSteps.vue'));

//componentes no admin pra controle da home da loja
Vue.component('store-home-cards-list', () => import('@/components/StoreHomeCardsList.vue'));
Vue.component('select-highlighted-products', () => import('@/components/SelectHighlightedProducts.vue'));

Vue.component('license-card-characteristics', () => import('@/components/LicenseCardCharacteristics'));

Vue.component('images-list', () => import('@/components/products-store/ImagesList.vue'));

Vue.component('renew-templates-modal', () => import('@/components/RenewTemplatesModal.vue'));

Vue.component('renew-themes-modal', () => import('@/components/RenewThemesModal.vue'));

Vue.component('allow-items-to-online-accounts', () => import('@/components/AllowItemsToOnlineAccounts.vue'));

Vue.component('update-selected-items-name', () => import('@/components/UpdateSelectedItemsName.vue'));

Vue.component('online-account-form', () => import('@/components/OnlineAccountForm.vue'));
Vue.component('online-account-update-form', () => import('@/components/OnlineAccountUpdateForm.vue'));

Vue.component('theme-paper-format', () => import('@/components/ThemePaperFormat.vue'));

Vue.component('admin-user-form', () => import('@/components/AdminUserForm.vue'));

Vue.component('register-segment', () => import('@/components/RegisterSegment.vue'));
Vue.component('erp-integration-selection', () => import('@/components/ERPIntegrationSelection.vue'));
Vue.component('cpf-cnpj-register', () => import('@/components/CpfCnpjRegister.vue'));

Vue.component('print-or-download-poster', () => import('@/components/PrintOrDownloadPoster.vue'));

Vue.component('flash-modal', () => import('@/components/FlashModal.vue'));

Vue.component('datepicker', Datepicker);

Vue.component('templates-export', () => import('@/components/TemplatesExport.vue'));

Vue.component('news-carousel', () => import('@/components/NewsCarousel.vue'));

Vue.component('online-account-historic-modal', () => import('@/components/OnlineAccountHistoricModal.vue'));

Vue.component('online-account-charge', () => import('@/components/OnlineAccountCharge.vue'));

Vue.component('online-account-cancel-subscription', () => import('@/components/OnlineAccountCancelSubscription.vue'));

// Vue.component('online-account-automation-data', () => import('@/components/OnlineAccountAutomationData.vue'));

Vue.component('draft-poster-table-line', () => import('@/components/DraftPosterTableLine.vue'));

Vue.component('import-specific-posters', () => import('@/components/ImportSpecificPosters.vue'));

Vue.component('qr-bar-code-reader', () => import('@/components/QrBarCodeReader.vue'));

Vue.component('show-selected-posters', () => import('@/components/ShowSelectedPosters.vue'));

Vue.component('sync-posters', () => import('@/components/SyncPosters.vue'));

Vue.component('update-register-promotions-label', () => import('@/components/UpdateRegisterPromotionsLabel.vue'));

Vue.component('editor', () => import('@/components/Editor.vue'));

Vue.component('reset-posters-counter', () => import('@/components/ResetPostersCounter.vue'));

Vue.component('submit-my-profile-form', () => import('@/components/SubmitMyProfileForm.vue'));

Vue.component('privacy-policy', () => import('@/components/PrivacyPolicy.vue'));

Vue.component('search-poster-by-scan', () => import('@/components/app-magalu/SearchPosterByScan.vue'));

Vue.component('poster-queue-list', () => import('@/components/app-magalu/PosterQueueListAppMagalu.vue'));

Vue.component('poster-queue-item', () => import('@/components/app-magalu/PosterQueueItemAppMagalu.vue'));

Vue.component('poster-preview-magalu', () => import('@/components/app-magalu/PosterPreviewMagalu.vue'));

Vue.component('loader-app-magalu', () => import('@/components/app-magalu/LoaderAppMagalu.vue'));

Vue.component('filter-posters-queue-app-magalu', () => import('@/components/app-magalu/FilterPostersQueueAppMagalu.vue'));

Vue.component('filler-app-magalu', () => import('@/components/app-magalu/filler/FillerAppMagalu.vue'));

Vue.component('modal-edit-draft-poster', () => import('@/components/draft-poster/ModalEditDraftPoster.vue'));

Vue.component('create-posters-in-bulk-through-drafts', () => import('@/components/draft-poster/CreatePostersInBulkThroughDrafts.vue'));

Vue.component('poster-preview', () => import('@/components/poster/PosterPreview.vue'));

Vue.component('poster-automation', () => import('@/components/poster-automation/PosterAutomation.vue'));

Vue.component('data-table-delete', () => import('@/components/DataTableDelete.vue'));

Vue.component('fixed-menu-app-magalu', () => import('@/components/app-magalu/FixedMenuAppMagalu.vue'));

Vue.component('api-refresh-token-modal', () => import('@/components/api/ApiRefreshTokenModal.vue'));
Vue.component('api-disable-modal', () => import('@/components/api/ApiDisableModal.vue'));

// App tagsell
Vue.component('search-poster-by-scan-app-tagsell', () => import('@/components/app-tagsell/SearchPosterByScan.vue'));

Vue.component('poster-queue-list-app-tagsell', () => import('@/components/app-tagsell/PosterQueueListAppTagsell.vue'));

Vue.component('poster-queue-item-app-tagsell', () => import('@/components/app-tagsell/PosterQueueItemAppTagsell.vue'));

Vue.component('poster-preview-app-tagsell', () => import('@/components/app-tagsell/PosterPreviewTagsell.vue'));

Vue.component('loader-app-tagsell', () => import('@/components/app-tagsell/LoaderAppTagsell.vue'));

Vue.component('filter-posters-queue-app-tagsell', () => import('@/components/app-tagsell/FilterPostersQueueAppTagsell.vue'));

Vue.component('filler-app-tagsell', () => import('@/components/app-tagsell/filler/FillerAppTagsell.vue'));
Vue.component('fixed-menu-app-tagsell', () => import('@/components/app-tagsell/FixedMenuAppTagsell.vue'));


// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js